export const CONFIGURATION_PERMISSION_CODES = {
  VIEW_SECTION: 'CONFIGURACION.VER_SECCION_163',
  COMPANY: 'CONFIGURACION.EMPRESA',
  COMPANY_VIEW_SECTION: 'CONFIGURACION.VER_SECCION_165',
  EDIT_REGIONAL_CONFIG: 'CONFIGURACION.EDITAR_CONFIGURACION_REGIONAL',
  CREATE_BRANCH: 'CONFIGURACION.CREAR_SUCURSAL',
  EDIT_BRANCH: 'CONFIGURACION.EDITAR_SUCURSAL',
  DELETE_BRANCH: 'CONFIGURACION.BORRAR_SUCURSAL',
  USERS: 'CONFIGURACION.USUARIOS',
  USERS_VIEW_SECTION: 'CONFIGURACION.VER_SECCION_171',
  CREATE_USER: 'CONFIGURACION.CREAR_USUARIO',
  EDIT_USER: 'CONFIGURACION.EDITAR_USUARIO',
  DELETE_USER: 'CONFIGURACION.BORRAR_USUARIO',
  PROFILES_AND_ROLES: 'CONFIGURACION.PERFILES_Y_ROLES',
  PROFILES_AND_ROLES_VIEW_SECTION: 'CONFIGURACION.VER_SECCION_176',
  CREATE_ROLE: 'CONFIGURACION.CREAR_ROL',
  EDIT_ROLE: 'CONFIGURACION.EDITAR_ROL',
  DELETE_ROLE: 'CONFIGURACION.BORRAR_ROL',
  DATA_MANAGEMENT: 'CONFIGURACION.GESTION_DE_DATOS',
  DATA_MANAGEMENT_VIEW_SECTION: 'CONFIGURACION.GESTION_DE_DATOS.VER_SECCION',
  AUTO_ROTATION: 'CONFIGURACION.ROLEO_AUTOMATICO',
  AUTO_ROTATION_VIEW_SECTION: 'CONFIGURACION.VER_SECCION_182',
  EXPORT_IMPORT: 'CONFIGURACION.EXPORTAR_IMPORTAR',
  EDIT_AUTO_ROTATION: 'CONFIGURACION.EDITAR_ROLEO_AUTOMATICO',
  PROTOCOLS: 'CONFIGURACION.PROTOCOLOS',
  PROTOCOLS_VIEW_SECTION: 'CONFIGURACION.VER_SECCION_186',
  ACCESS_PROMPTS: 'CONFIGURACION.PROTOCOLOS.ACCESO_A_PROMPTS',
  CREATE_PROTOCOL: 'CONFIGURACION.CREAR_PROTOCOLO',
  VIEW_PROTOCOL: 'CONFIGURACION.VER_PROTOCOLO',
  EDIT_PROTOCOL: 'CONFIGURACION.EDITAR_PROTOCOLO',
  DELETE_PROTOCOL: 'CONFIGURACION.BORRAR_PROTOCOLO',
  DOCUMENTS: 'CONFIGURACION.DOCUMENTOS',
  DOCUMENTS_VIEW_SECTION: 'CONFIGURACION.VER_SECCION_192',
  CREATE_DOCUMENT: 'CONFIGURACION.CREAR_DOCUMENTO',
  VIEW_DOCUMENT: 'CONFIGURACION.VER_DOCUMENTO',
  EDIT_DOCUMENT: 'CONFIGURACION.EDITAR_DOCUMENTO',
  DELETE_DOCUMENT: 'CONFIGURACION.BORRAR_DOCUMENTO',
  PAYMENTS_AND_SUBSCRIPTIONS: 'CONFIGURACION.PAGOS_Y_SUSCRIPCIONES',
  PAYMENTS_VIEW_SECTION: 'CONFIGURACION.VER_SECCION_198',
  SET_DEFAULT_PAYMENT: 'CONFIGURACION.ESTABLECER_PREDETERMINADO',
  ADD_PAYMENT_METHOD: 'CONFIGURACION.AGREGAR_METODO_DE_PAGO',
  EDIT_PAYMENT_METHOD: 'CONFIGURACION.EDITAR_METODO_DE_PAGO',
  DELETE_PAYMENT_METHOD: 'CONFIGURACION.BORRAR_METODO_DE_PAGO',
  CHANGE_PLAN: 'CONFIGURACION.CAMBIAR_PLAN',
  CANCEL_SUBSCRIPTION: 'CONFIGURACION.CANCELAR_SUSCRIPCION',
  AUDIT_LOG: 'CONFIGURACION.LOG_AUDITORIA',
  AUDIT_LOG_VIEW_SECTION: 'CONFIGURACION.VER_SECCION_206',
  SUBSTITUTION: 'CONFIGURACIÓN.SUPLENCIAS',
  SUBSTITUTION_VIEW_SECTION: 'CONFIGURACIÓN.SUPLENCIAS.VER_SECCION',
  CREATE_SUBSTITUTION: 'CONFIGURACIÓN.SUPLENCIAS.CREAR_SUPLENCIA',
  EDIT_SUBSTITUTION: 'CONFIGURACIÓN.SUPLENCIAS.EDITAR_SUPLENCIA',
  DELETE_SUBSTITUTION: 'CONFIGURACIÓN.SUPLENCIAS.ELIMINAR_SUPLENCIA',
  INTEGRATION: 'CONFIGURACION.INTEGRACION',
  INTEGRATION_VIEW_SECTION: 'CONFIGURACION.INTEGRACION.VER_SECCION',
  LOG_LOGIN: 'CONFIGURACION.LOG_LOGIN',
  LOG_LOGIN_VIEW_SECTION: 'CONFIGURACION.LOG_LOGIN.VER_SECCION',
};
